import { html, nothing, render } from "lit-html";
import { createRef, ref } from "lit-html/directives/ref.js";
import { classMap } from "lit-html/directives/class-map.js";
import unsaferHTML from "@escapio/shared/unsaferHTML";
import { translate } from "@escapio/shared/l10n/translate";
import { stateful } from "@escapio/shared/components/element-builder";
import { track } from "@escapio/portal/tracker/EventTracker.js";
import "@escapio/shared/components/Picture";
import { ContextCriteriaPicturePopup } from "./ContextCriteriaPicturePopup";

customElements.define(
	"esc-hotel-list-content-criteria",
	stateful(
		class extends HTMLElement {
			static getInitialState() {
				return {
					image: null,
					hotel: null,
					title: "",
					text: "",
					showComplete: false,
					textRef: null,
					textElem: null,
					popup: null,
				};
			}

			connectedCallback() {
				this.textRef = createRef();
			}

			render() {
				/*
				 * Hack: avoid showing "more"-button for 2 line long texts
				 * Weirdly these text get a scrollHeight of 37px and therefore
				 * exceed the limit of 2 * line-height. Since all texts with 3 lines
				 * and more will be a lot larger than 37px,
				 * this threshold of 2px should be fine for all texts.
				 */
				const textIsTruncated =
					this.textElem &&
					this.textElem.offsetHeight + 2 < this.textElem.scrollHeight;
				const template = html`${this.image
						? html`<div
								class="context-criteria__image-container picture--expandable"
								@pointerenter=${this.hoverContextCriteriaImage}
								@click=${this.clickContextCriteriaImage}
							>
								<esc-picture
									class="context-criteria__image"
									type="hotel"
									filename=${this.image.filename}
									alt="${this.imageAlt}"
									sizes="desktop:100x100"
									?onhold=${this.imageOnHold}
								></esc-picture>
							</div> `
						: html`<div class="context-criteria__image"></div>`}
					<section class="context-criteria__content">
						<header class="context-criteria__content__title">
							${this.title}
						</header>
						<p
							class="${classMap({
								"context-criteria__content__text": true,
								"context-criteria__content__text--collapsed":
									!this.showComplete,
							})}"
							${ref(this.textRef)}
						>
							${unsaferHTML(this.text)}
						</p>
						${textIsTruncated && !this.showComplete
							? html` <button
									class="context-criteria__button-expand"
									@click=${this.expandContextCriteria}
								>
									${translate("basic_more")}
								</button>`
							: nothing}
					</section>`;
				render(template, this, { host: this });
				if (!this.textElem) {
					this.textElem = this.textRef.value;
				}
			}

			expandContextCriteria() {
				this.showComplete = true;
				this.track("Klick MC ausklappen");
			}

			hoverContextCriteriaImage() {
				this.track("Hover MC-Bild");
			}

			clickContextCriteriaImage() {
				if (!this.popup) {
					this.popup = new ContextCriteriaPicturePopup();
				}
				this.popup.show(this.image);
				this.track("Klick MC-Bild");
			}

			track(action) {
				track("Liste", action, `${this.hotel.id} | ${this.hotel.name}`);
			}
		},
	),
);
